import React from 'react';
import logoImage from '../assets/images/logo1.png'; // replace with your real image path

const Logo = () => {
  return (
    <div className="text-center pb-5 ">
      <img
        src={logoImage}
        alt="Brand Logo"
        style={{ width: '250px', height: 'auto',  marginTop:'-45px' }}
      />
      <p style={{  color: '#ffffffff' , marginTop:'-45px' }}>“Moments That Last Forever”</p>
      <p style={{  color: '#ffffffff' }}>Design Studio • Phnom Penh, Cambodia</p>
    </div>
  );
};

export default Logo;